import {
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import { TEMPLATES } from "../components/templates";

function TemplateSection() {
  const navigate = useNavigate();
  const scrollRef = useRef();

  const templates = TEMPLATES.filter((t) => t.category === "popular").slice(0, 10);

  const handleSelect = (template) => {
    navigate("/create-biodata", {
      state: {
        selectedBg: template.value,
        theme: template.theme,
      },
    });
  };

  // ✅ Scroll handlers
  const scroll = (direction) => {
    const container = scrollRef.current;
    if (!container) return;

    const scrollAmount = 300;

    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <Box sx={{ px: 2, py: 6, position: "relative" }}>
      {/* ===== Title ===== */}
      <Typography
        variant="h5"
        sx={{ fontWeight: 700, mb: 1, textAlign: "center" }}
      >
        Choose Your Biodata Template
      </Typography>

      <Typography
        sx={{
          textAlign: "center",
          color: "#666",
          mb: 3,
          fontSize: "0.95rem",
        }}
      >
        Click any template to start instantly
      </Typography>

      {/* ===== LEFT ARROW ===== */}
      <IconButton
        onClick={() => scroll("left")}
        sx={{
          position: "absolute",
          left: 0,
          top: "55%",
          transform: "translateY(-50%)",
          zIndex: 2,
          background: "#fff",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          "&:hover": { background: "#fff" },
        }}
      >
        <ArrowBackIosNewIcon />
      </IconButton>

      {/* ===== RIGHT ARROW ===== */}
      <IconButton
        onClick={() => scroll("right")}
        sx={{
          position: "absolute",
          right: 0,
          top: "55%",
          transform: "translateY(-50%)",
          zIndex: 2,
          background: "#fff",
          boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
          "&:hover": { background: "#fff" },
        }}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      {/* ===== SCROLL CONTAINER ===== */}
      <Box
        ref={scrollRef}
        sx={{
          display: "flex",
          gap: 2,
          overflowX: "auto",
          scrollBehavior: "smooth",
          pb: 2,

          // ❌ Hide scrollbar
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
        }}
      >
        {templates.map((template, i) => (
          <Box
            key={i}
            onClick={() => handleSelect(template)}
            sx={{
              minWidth: 240,
              height: 340,
              borderRadius: 2,
              backgroundImage: `url(${template.key})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              flexShrink: 0,
              boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
              cursor: "pointer",
              transition: "0.3s",
              position: "relative",

              "&:hover": {
                transform: "scale(1.05)",
              },

              "&:hover .overlay": {
                opacity: 1,
              },
            }}
          >
            {/* Overlay */}
            <Box
              className="overlay"
              sx={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0.4), rgba(0,0,0,0.75))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                opacity: 0,
                transition: "0.3s",
                color: "#fff",
                fontWeight: 600,
              }}
            >
              Use Template
            </Box>

            {/* Badge */}
            <Box
              sx={{
                position: "absolute",
                top: 8,
                left: 8,
                background: "#FF5E62",
                color: "#fff",
                px: 1,
                py: 0.3,
                fontSize: "0.7rem",
                borderRadius: 1,
                fontWeight: 600,
              }}
            >
              Popular
            </Box>
          </Box>
        ))}
      </Box>

      {/* CTA */}
      <Box sx={{ textAlign: "center", mt: 3 }}>
        <Button
          variant="outlined"
          onClick={() => navigate("/marriage-biodata-templates")}
          sx={{
            borderRadius: 3,
            px: 3,
            py: 1,
            textTransform: "none",
            fontWeight: 600,
          }}
        >
          View All Templates
        </Button>
      </Box>
    </Box>
  );
}

export default TemplateSection;